import { registerPlugin } from '@capacitor/core'
import type { PluginListenerHandle } from '@capacitor/core'

export interface SocketPlugin {
  /**
   * Open a TCP socket connection
   */
  open(options: { socketKey: string; address: string; port: number }): Promise<void>

  /**
   * Write data to the socket
   */
  write(options: { socketKey: string; data?: string; dataBytes?: number[] }): Promise<void>

  /**
   * Shutdown write on the socket
   */
  shutdownWrite(options: { socketKey: string }): Promise<void>

  /**
   * Close the socket connection
   */
  close(options: { socketKey: string }): Promise<void>

  /**
   * Check if socket is closed
   */
  isClosed(options: { socketKey: string }): Promise<{ closed: boolean }>

  /**
   * Add listener for data received
   */
  addListener(
    eventName: 'data',
    listenerFunc: (data: { socketKey: string; data: string }) => void
  ): Promise<PluginListenerHandle>

  /**
   * Add listener for errors
   */
  addListener(
    eventName: 'error',
    listenerFunc: (error: { socketKey: string; message: string; errorType?: string }) => void
  ): Promise<PluginListenerHandle>

  /**
   * Add listener for close events
   */
  addListener(
    eventName: 'close',
    listenerFunc: (event: { socketKey: string; hasError: boolean }) => void
  ): Promise<PluginListenerHandle>

  /**
   * Remove all listeners for an event
   */
  removeAllListeners(eventName?: string): Promise<void>
}

const Socket = registerPlugin<SocketPlugin>('Socket')

export { Socket }
